import { createContext } from 'react';
import { ModalEffectApi } from './modal/modal-effect.api';
import { PopupEffectApi } from './popup/popup-effect.api';

type EffectContextType = {
  popupApi: PopupEffectApi;
  modalApi: ModalEffectApi;
};

export const EffectContext = createContext<EffectContextType>({
  popupApi: {
    push: () => {},
    pop: () => {},
  },
  modalApi: {
    push: () => {},
    pop: () => {},
  },
});
